import { FormGroup, Validators } from "@angular/forms";

export class FormValidationUtil {
  public static setRequiredValidatorVal(form: FormGroup, formControl: string) {
    form.controls[formControl].setValidators(
      Validators.required
    );
    form.controls[
      formControl
    ].updateValueAndValidity();
  }

  public static changeFormControlValidators(form: FormGroup, formControl: string, newVal: any) {
    form.controls[formControl].setValue(newVal);
    form.controls[formControl].clearValidators();
    form.controls[
      formControl
    ].updateValueAndValidity();
  }
}
